import { call, put, takeLatest } from "redux-saga/effects";
import { notification } from "antd";
import { GET, POST, PUT } from "../../api";
import ApiRouts from "../../api/routes";
import { FETCH_ACTIVE_LICENSE } from "../actions";
import { setActiveLicense } from "./action";

function* fetchActiveLicenseSaga(action) {
    try {
        const response = yield call(PUT, `${ApiRouts.API_ACTIVE_LICENSE}`, action.payload.licenseData);
        if (response) {
            yield put(setActiveLicense(response.status));
            const license = action.payload.licenseData.license;
            localStorage.setItem("active_license", license);
        } else {
            throw new Error("Failed to fetch the license.");
        }
    } catch (error) {
        notification.error({
            message: "Activation License Failed",
            description: error.response?.data?.message || "Something went wrong!",
            placement: "topRight",
        });
    }
}

function* activeLicenseSaga() {
    yield takeLatest(FETCH_ACTIVE_LICENSE, fetchActiveLicenseSaga);
}


export default activeLicenseSaga;
